import { type FeatureFlagsContextType } from "./types";

export const defaultFeatureFlagsContext: FeatureFlagsContextType = {
  isTidEnabled: true,
  isManageUserAccessEnabled: true,
};
